// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>
import GlobalStyles from '../../../config/styles';

const styles = () => ({
  // Sub-heading for the screen, now that it sits inside the account shell
  // rather than carrying its own PaperLayout title.
  screenTitle: {
    margin: '16px 0 0 0',
    textAlign: 'center',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    color: GlobalStyles.color.COLOR_GRAY,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    // See the issue-voucher screen: the fixed-width column has to centre
    // itself now that PaperLayout is not wrapping it.
    width: '290px',
    margin: '0 auto',
    padding: '8px 0 32px 0',
    justifyContent: 'flex-start',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  loaderContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
});

export default styles;
